export default function TrustSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto relative">
        <div className="relative">
          <div className="absolute -top-8 -left-4 md:-left-8 opacity-20">
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
              <path d="M20 100 Q40 20 60 50 Q80 80 100 10" stroke="currentColor" strokeWidth="1.5" fill="none" className="text-foreground-400"/>
              <path d="M10 90 Q25 30 50 55 Q70 75 90 20" stroke="currentColor" strokeWidth="1" fill="none" className="text-foreground-300"/>
            </svg>
          </div>

          <div className="bg-primary-500 rounded-3xl overflow-hidden relative">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-[42%] relative min-h-[280px] md:min-h-[420px]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20clean%20bright%20workspace%20scene%20with%20an%20open%20laptop%20on%20a%20light%20birch%20wood%20desk%20showing%20colorful%20data%20visualization%20charts%20on%20screen%2C%20a%20steaming%20ceramic%20mug%20in%20soft%20sage%20color%2C%20a%20small%20potted%20succulent%20plant%2C%20and%20scattered%20handwritten%20research%20sticky%20notes%2C%20morning%20light%20flooding%20through%20sheer%20curtains%2C%20calm%20productive%20atmosphere%2C%20modern%20home%20office%20aesthetic%2C%20no%20person%20visible&width=700&height=900&seq=kakobuy-trust-v2-01&orientation=portrait"
                  alt="Modern workspace with kakobuy spreadsheet research tools"
                  title="Kakobuy Spreadsheet Research Workspace"
                  className="w-full h-full object-cover object-top rounded-2xl md:rounded-none md:rounded-l-3xl"
                />
              </div>

              <div className="md:w-[58%] p-8 md:p-12 flex flex-col justify-center">
                <span className="text-7xl md:text-8xl font-heading font-bold text-accent-300 leading-none opacity-60 mb-4">&ldquo;</span>
                <blockquote className="text-background-50 text-lg md:text-xl leading-relaxed font-light mb-6">
                  The kakobuy spreadsheet completely transformed how I approach product research. Instead of spending hours scrolling through endless listings, I now have a structured database that lets me compare products side by side, check verified reviews, and make confident purchasing decisions in minutes rather than hours.
                </blockquote>
                <div className="mb-8">
                  <p className="text-background-50 text-sm font-semibold">Alex Morgan</p>
                  <p className="text-background-400 text-xs">Product Research Analyst &amp; Spreadsheet Enthusiast</p>
                </div>
                <a
                  href="/kakobuy-spreadsheet-guide"
                  className="inline-block px-6 py-3 rounded-full bg-accent-400 text-primary-800 text-sm font-semibold hover:bg-accent-300 transition-colors cursor-pointer whitespace-nowrap w-fit"
                >
                  Read Full Review
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}